<z-select
    #select
    id="{{ id() }}"
    [options]="options()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [placeholder]="placeholder()"
    [disabled]="disabled ?? false"
    [class]="class"
    [label]="showLabel() == true ? label() : ''"
    [class]="class"
    [filter]="false"
    [filterBy]="'Name'"
    [showClear]="false"
    [(ngModel)]="model"
    (keydown)="onKeyDown($event)"
    (ngModelChange)="modelChange($event)"
    [ngModelOptions]="{ standalone: true }"
/>
